<template>
  <b-card header="Opciones de Filtro" class="card-filter">
    <b-btn class="filter-collapse" 
        variant="primary" 
        size="sm"
        @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
      <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
    </b-btn>
    <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
      <b-form>
        <b-form-group
          :label= 'nombreLeyenda'
          label-for="nombre"
          :label-cols="2"
          horizontal>
          <b-form-input id="nombre" 
            v-model="filtro.nombre" 
            type="text"></b-form-input>
        </b-form-group>
        
        <b-form-group
          v-if="showOpcionInactivos"
          label-for="inactivo"
          :label-cols="2">
          <b-form-checkbox 
              id="inactivo"
              v-model="filtro.incluirInactivos"
              value= true
              unchecked-value= false>
              {{ incluirInactivosLeyenda }}
          </b-form-checkbox>
        </b-form-group>
      </b-form>

    <div class="footer">
      <b-button size="sm" variant="primary" class="footer-button"
        @click.prevent="filtrar">Filtrar</b-button>
      <b-button size="sm" variant="primary" class="footer-button" 
        @click.prevent="limpiarFiltro">Limpiar</b-button>
    </div>

    </b-collapse>
    <!--
    <div slot="footer" class="footer" v-if="showOpcionesFiltro">
      <b-button size="sm" variant="primary" class="footer-button"
        @click.prevent="filtrar">Filtrar</b-button>
      <b-button size="sm" variant="primary" class="footer-button" 
        @click.prevent="limpiarFiltro">Limpiar</b-button>
    </div>
    -->
  </b-card>  
</template>

<script>
import moment from 'moment';

export default {
  components: {
  },
  props: {
    nombre: {
      type: String,
      default: ''
    },
    nombreLeyenda: {
      type: String,
      default: 'Nombre'
    },
    showOpcionInactivos: {
      type: Boolean,
      default: Boolean(true)
    },
    incluirInactivos: {
      type: Boolean,
      default: Boolean(false)
    },
    incluirInactivosLeyenda: {
      type: String,
      default: 'Incluir inactivos'
    }
  },
  data() {
    return {
      filtro: {
        nombre: '',
        incluirInactivos: Boolean(false),
      },
      showOpcionesFiltro: Boolean(false)      
    }
  },
  created() {
      this.filtro.nombre = this.nombre;
      this.filtro.incluirInactivos = this.incluirInactivos;
  },
  computed: {
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.nombre = '';
      this.filtro.incluirInactivos = Boolean(false);
    },
  },
}
</script>

<style>
</style>
